import parse from 'date-fns/parse'

const moment = require("moment");

export const DATE_FORMAT_YYYYMMDD = "YYYY-MM-DD";

export function get30DaysAgo_YYYYMMDD() {
  let today = moment();

  let thirtyDaysAgo = today.subtract(30, "days");
  
  return thirtyDaysAgo.format(DATE_FORMAT_YYYYMMDD);
}

export function get29DaysAgo_YYYYMMDD() {
  let momentDate = moment();

  let twentyNineDaysAgo = momentDate.subtract(29, "days");
  
  return twentyNineDaysAgo.format(DATE_FORMAT_YYYYMMDD);
}

export function get30DaysAgoFromDate_YYYYMMDD(date) {
  let momentDate = moment(date);

  let thirtyDaysAgo = momentDate.subtract(30, "days");
  
  return thirtyDaysAgo.format(DATE_FORMAT_YYYYMMDD);
}

export function get29DaysAgoFromDate_YYYYMMDD(date) {
  let momentDate = moment(date);

  let twentyNineDaysAgo = momentDate.subtract(29, "days");
  
  return twentyNineDaysAgo.format(DATE_FORMAT_YYYYMMDD);
}

export function get11MonthsAgo_YYYYMMDD() {
  let today = moment();

  let elevenMonthsAgo = today.subtract(11, "months");
  
  return elevenMonthsAgo.format(DATE_FORMAT_YYYYMMDD);
}

export function get11MonthsAgoFromDate_YYYYMMDD(date) {
  let momentDate = moment(date);

  let elevenMonthsAgo = momentDate.subtract(11, "months");
  
  return elevenMonthsAgo.format(DATE_FORMAT_YYYYMMDD);
}

export function geLastMonthEnd_YYYYMMDD() {
  let today = moment();

  let lastMonthEndDay = today.subtract(1, "months").endOf('month');
  
  return lastMonthEndDay.format(DATE_FORMAT_YYYYMMDD);
}

export function getToday_YYYYMMDD() {
  let today = moment();
  
  return today.format(DATE_FORMAT_YYYYMMDD);
}

export function dateToYYYYMMDD(date) {
  let momentDate = moment(date);
  
  return momentDate.format(DATE_FORMAT_YYYYMMDD);
}

export function timestampInSecondToDateUTCDDMMYYYYHHmm(timestampInSecond, i18n) {
  let dateTimeFormat = 'YYYY-MM-DD HH:mm' //English date
  if(i18n.language === 'fr') {
    dateTimeFormat = 'DD-MM-YYYY HH:mm'
  } else if (i18n.language === 'en_us') {
    dateTimeFormat = 'MM-DD-YYYY h:mm a' //American date
  }
  return moment.unix(timestampInSecond).utc().format(dateTimeFormat);
}

export function timestampInSecondToDayForDayListUTC(timestampInSecond) {
  return moment.unix(timestampInSecond).utc().format("YYYY-M-D");
}

export function timestampInSecondToDayUTC(timestampInSecond) {
  return moment.unix(timestampInSecond).utc().format("DD-MM-YYYY");
}

export function timestampInSecondToMonthUTC(timestampInSecond) {
  return moment.unix(timestampInSecond).utc().format("MM-YYYY");
}

export function timestampInSecondFromCertificateEndDateToMonthUTCYYYYMM(timestampInSecond, i18n) {
  let monthFormat = 'YYYY-MM'
  if(i18n.language === 'fr') {
    monthFormat = 'MM-YYYY'
  }
  return moment.unix(timestampInSecond).subtract(12, "hours").subtract(1, "ms").utc().format(monthFormat);
}

export function timestampInSecondToYearUTC(timestampInSecond) {
  return moment.unix(timestampInSecond).utc().format("YYYY");
}

//Functions to use in Date & Time pickers to get the date in utc and display it in utc

export function jsDateToLocalISO8601DateString(date) {
  let fullYear = String(date.getFullYear());
  let month = String(101 + date.getMonth()).substring(1);
  let day = String(100 + date.getDate()).substring(1);
  let hours = (date.getHours()<10?'0':'') +date.getHours();
  let minutes = (date.getMinutes()<10?'0':'') +date.getMinutes();

  let isoDate = fullYear+'-'+month+'-'+day+'T'+hours+':'+minutes+':00Z'

  return(isoDate)
}

export function dateStringToLocalDate(s) {
  s = typeof s === 'string' ? s : moment(s).format('YYYY-MM-DDTHH:mm:ss')
  s = s.replace('T', ' ')
  s = s.replace('Z', '')
  if (!s) return null;
  let dateToReturn = parse(s, 'yyyy-MM-dd HH:mm:ss', new Date())
  return dateToReturn;
}



// WEBPACK FOOTER //
// ./src/utils/date.js